import joinUrl from "../../utils/join-url";
import requestUtility from "../../helpers/request-utility";

const createBillingProfile = (apiUrl) => (data) => {
  const url = joinUrl(apiUrl, `/checkoutservice/pb/billing-profiles/`);
  return requestUtility.post(url, data);
};

export default createBillingProfile;
